<template>
<div class="main" >
    <form @submit.prevent="handleSubmit">
        <p style="color: red; font-weight: bold; text-align: center;">55^ Festa della Gnoccata</p>
        <p><span style="font-weight: 400;">Nei giorni della Festa della Gnoccata puoi prenotare il tuo tavolo fino ad esaurimento dei posti disponibili scegliendo fra i turni proposti ogni giorno.</span></p>
<p><span style="font-weight: 400;">Il gioved&igrave;, il venerd&igrave; ed il sabato sera il</span><strong> primo turno &egrave; alle ore 19.00</strong><span style="font-weight: 400;"> (si pu&ograve; arrivare al massimo alle ore 20.00)</span> 
    <span style="font-weight: 400;">, il</span><strong> secondo turno alle ore 21.30</strong><span style="font-weight: 400;"> e il <strong> terzo turno dalle ore 22.30</strong>, con coperti limitati.</span></p>
<p><span style="font-weight: 400;">La domenica puoi prenotare a pranzo </span><strong>il turno ore 12.00 </strong><span style="font-weight: 400;">e </span><strong> oppure delle ore 14.00.</strong></p>
<p><a href="MENUSALA.pdf" target="_blank"><strong>Leggi il men&ugrave; della Festa della Gnoccata&nbsp;</strong></a></p>
<p><span style="font-weight: 400;">Qui di seguito puoi effettuare la tua prenotazione:</span></p>
<div class="space">
            
        </div>
        
        <label>Email :</label>
        <input type="email" v-model="email" required>
        <div v-if="passwordError" class="error">{{ passwordError }} </div>

        <label>Cognome Nome :</label>  
        <input type="text" v-model="cognomenome"  minlength="4" required>            
       

        <label>Telefono :</label>  
        <input type="tel" v-model="numerotelefono" required>      
       
        <label>Data :</label>
        <select v-model="giorno" v-on:change="modificafasciaoraria">
            <option value="0810">Giovedì 8 Ottobre 2026</option>
            <option value="0910">Venerdì 9 Ottobre 2026</option>
            <option value="1010">Sabato 10 Ottobre 2026</option>
            <option value="1110">Domenica 11 Ottobre 2026</option>
        </select>

     
        <label>Fascia Oraria :</label>
        <select v-model="fasciaoraria" v-on:change="disponibilita">
            <option v-for="fasciaoraria in list" :key="fasciaoraria.id" :value="fasciaoraria.id" >{{ fasciaoraria.name }} </option>
        </select>

        <label>Coperti Disponibili :</label>
        {{postidisponibili}}


          <div v-if="postidisponibili < 4 &&  inlistaattesa < 20 && giorno !== '' && fasciaoraria !== ''" class="lista-attesa">
            <input type="checkbox" v-model="listaAttesa" id="listaAttesa">
            <label for="listaAttesa" style="width:80%; text-transform: none;">Aggiungi alla lista d'attesa</label>
        </div>

        <div class="space">
            
        </div>
        <label>Coperti :</label>  
        <input type="number" v-model="coperti" required>   
        <div v-if="copertiError" class="error"><span v-html="copertiError"></span></div>

        <div class="space">
            
        </div>

        <label>Note :</label>  
        <input type="text" v-model="note"  >            

        <div class="space">
            
        </div>
        <div>
            <input type="checkbox" v-model="terms" required>
            <label style="width:80%;">Ho letto, compreso e accettato i <a href="https://www.smsserpiolle.it/privacy-policy-sms-serpiolle/" target="_blank">termini e condizioni</a></label>
        </div>
        <div class="space">
            
        </div>
        <div class="button">
            <button class="submit" :disabled="isLoading" type="submit">PRENOTA</button>
        </div>
    </form>

  
</div>

</template>


<script>
import jquery from "jquery";


export default{
    data() {
        return {
            showMain : true,
            showSuc : false,
            isLoading: false,
            email: '',
            note: '',
            cognomenome: '',
            numerotelefono: '',
            giorno: '',
            fasciaoraria: '',
            education: [],
            terms: false,
            listaAttesa: false,
            passwordError: '',
            copertiError: '',
            coperti:0,
            postidisponibili:0,
            inlistaattesa:0,
            list: [
                    {id: 1, name: "19:00", value: "1900"},
                    {id: 2, name: "21:30", value: "2130"},
            ],
            toserver: {email: '',cognomenome: '',giorno: '',
            fasciaoraria: '', numerotelefono: '', coperti : 0, asporto: 0,testoasporto:'', note:'', listaAttesa : ''},
            toserverDisponibilita: {giorno: '',fasciaoraria: ''}
        }
    },
    methods: {
        paginaloada()
       { 
        
        if (this.$route.query.pagina == 'about') 
            {
            this.$router.push("about")
        }
        if (this.$route.query.pagina == 'AdminCsvDownload') 
        {
            this.$router.push("AdminCsvDownload");
        }
        if (this.$route.query.pagina == 'ConfermaPrenotazione') 
            {
            this.$router.push("ConfermaPrenotazione?id=" + this.$route.query.id + "&email=" + this.$route.query.email + "&giorno="  + this.$route.query.giorno + "&cognomenome=" + this.$route.query.cognomenome + "&securecode=" + this.$route.query.securecode)
            }
        if (this.$route.query.pagina == 'ModificaCoperti') 
            {
                var DataTrasformer = '';
                DataTrasformer = this.$route.query.data;

                DataTrasformer =DataTrasformer.replace('2024','');
                DataTrasformer = DataTrasformer.replace('2025','');
                DataTrasformer = DataTrasformer.replace('2026','');
                DataTrasformer = DataTrasformer.replace('/','');
                DataTrasformer = DataTrasformer.replace('/','');

                var fasciaoraria = this.$route.query.fascioraria;

                if (fasciaoraria == '19:00') { fasciaoraria = '1'; }
                if (fasciaoraria == '21:30') { fasciaoraria = '2'; }
                if (fasciaoraria == '22:30') { fasciaoraria = '3'; }

                if (fasciaoraria == '12:00') { fasciaoraria = '4'; }
                if (fasciaoraria == '14:00') { fasciaoraria = '5'; }


            this.$router.push("ModificaCoperti?id=" + this.$route.query.id + "&securecode=" + this.$route.query.securecode + "&email="  + this.$route.query.email + "&cognomenome=" + this.$route.query.cognomenome + '&coperti=' + this.$route.query.coperti + '&listaattesa=' + this.$route.query.listaattesa + '&Data=' + DataTrasformer + '&fasciaoraria=' + fasciaoraria)
            }
        if (this.$route.query.pagina == 'deletePrenotazione') 
            {
            this.$router.push("deletePrenotazione?id=" + this.$route.query.id + "&email=" + this.$route.query.email + "&giorno="  + this.$route.query.giorno + "&cognomenome=" + this.$route.query.cognomenome + "&securecode=" + this.$route.query.securecode)
            }
        },
       modificafasciaoraria()
       { 
           while(this.list.length > 0) {
               this.list.pop();
            }

           if (this.giorno == '1110') {
               this.list.push( {id: 4, name: "12:00", value: "1200"});
               this.list.push( {id: 5, name: "14:00", value: "1400"});
           } 
           else
           {
             this.list.push( {id: 1, name: "19:00", value: "1900"});
            this.list.push( {id: 2, name: "21:30", value: "2130"});
            this.list.push( {id: 3, name: "22:30", value: "2230"});
             }
          
          this.disponibilita();                              
        },
        disponibilita()
        {
            this.toserverDisponibilita.giorno = this.giorno;
            this.toserverDisponibilita.fasciaoraria = this.fasciaoraria;

            var datidainviare = this.toserverDisponibilita;
            let that = this;
            
            
            if ((this.giorno != '') && (this.fasciaoraria != '')) {
                jquery.ajax({
                    url: that.$hostname + "/Disponibilita.ashx",
                    type: "POST",
                    crossDomain: true,
                    data: JSON.stringify(datidainviare),
                    dataType: "json",
                    success: function (response) {
                        var resp = response;
                        
                        if (resp.Stato == 'OK') {
                            that.postidisponibili = parseInt(resp.Messaggio);
                            if (parseInt(resp.Messaggio) < 0) { that.postidisponibili = 0; }

                        } else
                        {
                            alert(resp.Messaggio);
                        }
                    },
                    error: function (xhr, status) {
                        alert("error" +  status + "  " + xhr);
                    }
                });
            }

            this.listaattesa();

        },
        listaattesa()
        {
            this.toserverDisponibilita.giorno = this.giorno;
            this.toserverDisponibilita.fasciaoraria = this.fasciaoraria;

            var datidainviare = this.toserverDisponibilita;
            let that = this;
            
            
            if ((this.giorno != '') && (this.fasciaoraria != '')) {
                jquery.ajax({
                    url: that.$hostname + "/ListaAttesa.ashx",
                    type: "POST",
                    crossDomain: true,
                    data: JSON.stringify(datidainviare),
                    dataType: "json",
                    success: function (response) {
                        var resp = response;
                        
                        if (resp.Stato == 'OK') {
                            that.inlistaattesa = parseInt(resp.Messaggio);
                            if (parseInt(resp.Messaggio) < 0) { that.inlistaattesa = 0; }

                        } else
                        {
                            alert(resp.Messaggio);
                        }
                    },
                    error: function (xhr, status) {
                        alert("error" +  status + "  " + xhr);
                    }
                });
            }

        }
        ,
        handleSubmit() {
            this.copertiError ="";
            
            if (parseInt(this.coperti) < 1) {
               this.copertiError ="Indicare il numero di coperti";
               return;
            
            }

            if ((parseInt(this.coperti) > 18) && !(this.email.toLowerCase() == "festadellagnoccata@smsserpiolle.it")) {
               this.copertiError ="Numero di coperti troppo elevato. Per prenotare tavoli più grandi di 18 scrivere a <a href='mailto:festadellagnoccata@smsserpiolle.it'>festadellagnoccata@smsserpiolle.it</a>";
               return;
            }

            if(!this.passwordError) {
                this.toserver.email = this.email;
                this.toserver.cognomenome = this.cognomenome;
                this.toserver.giorno = this.giorno;
                this.toserver.coperti = this.coperti;
                this.toserver.fasciaoraria = this.fasciaoraria;
                this.toserver.numerotelefono = this.numerotelefono;
                this.toserver.note = this.note;

                if (this.listaAttesa == true) {
                    this.toserver.listaAttesa = 'S';
                } else {
                    this.toserver.listaAttesa = '';
                }
                

                console.log(JSON.stringify(this.toserver));
                this.showSuc = true;
                this.showMain = false;
                var datidainviare = this.toserver;
                this.isLoading =true;

                let that = this;
                

                jquery.ajax({
                    url: this.$hostname + "/prenotazione.ashx",
                    type: "POST",
                    crossDomain: true,
                    data: JSON.stringify(datidainviare),
                    dataType: "json",
                    success: function (response) {
                        var resp = response;
                        
                        if (resp.Stato == 'OK' || resp.Stato == 'AT') {
                            if (resp.Stato == 'OK') {                                
                                that.isLoading =false;
                                that.$router.push('RiepilogoPrenotazione?email=' + datidainviare.email + '&cognomenome=' + datidainviare.cognomenome);
                            }
                            if (resp.Stato == 'AT') {
                                that.isLoading =false;
                                that.$router.push('RiepilogoPrenotazioneAttesa?email=' + datidainviare.email + '&cognomenome=' + datidainviare.cognomenome);
                            }
                            //window.location = 'ConfermaPrenotazione?email=' + datidainviare.email + '&cognomenome=' + datidainviare.cognomenome;
                        } else
                        {
                            alert(resp.Messaggio);
                            that.isLoading =false;
                            return;
                        }
                    },
                    error: function (xhr, status) {
                        alert("error" +  status + "  " + xhr);
                        that.isLoading =false;
                    }
                });
    

            }
        }
    },
    created() { 
        this.paginaloada();

    },
    
}
</script>


<style scoped> 

form {
    max-width: 600px;
    margin:  auto;
    background: #fff;
    text-align: left;
    padding: 20px;
    border-radius: 10px;
}

label {
    color: #aaa;
    display:inline-block;
    margin: 25px 0 15px;
    text-transform: uppercase;
}

input, select {
    display: block;
    padding: 10px 6px;
    width: 100%;
    box-sizing: bordre-box;
    border: none;
    border-bottom: 1px solid #ddd;
    color: #555;
}

input[type="checkbox"] {
    display: inline-block;
    width:16px;
    margin: 0 10px 0;
    position: relative;
    top: 2px;
}

.pill {
    display: inline-block;
    margin: 20px 10px 0 0 ;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    cursor: pointer;
    background: #eee;
}

button {
    background: rgb(255, 217, 2);
    border: 0;
    padding: 10px 20px;
    color: rgb(0, 0, 0);
    border-radius: 20px;
}

.submit {
    text-align: center;
}

.error {
    color: #ff0000;
    margin-top: 10px;
    font-size: 0.8em;
    font-weight: bold;
}

.space {
    margin-top: 30px;
}

</style>

